import React from 'react';
import { useSelector } from 'react-redux';
import { RootStore } from 'store/types';
import { ModalWindow, BodyText, Spinner, SpinnerSize, Header2Text } from 'ui-toolkit';
import { IStandardDocumentData } from '../../../../types/order/documents/shared/interfaces';
import { buildGetCategoryLabelByName } from '../../../../types/order/documents/IDocumentCategoryType';
import {
  defaultNormalizedDocumentCategoriesData,
  useListDocumentCategoriesQuery,
} from '../../../../API/documentCategories/DocumentCategoriesApi';

interface IFinalizeDocumentModal {
  docToFinalize: IStandardDocumentData | null;
  setDocToFinalize: (val: IStandardDocumentData | null) => void;
  onCloseFinalizeModal: () => void;
}

export const FinalizeDocumentModal: React.FC<IFinalizeDocumentModal> = ({
  docToFinalize,
  setDocToFinalize,
  onCloseFinalizeModal,
}) => {
  const {
    finalizeDocument: {
      fetchError,
      fetchStatus: { fetching, success },
    },
  } = useSelector((state: RootStore) => state.order.documents);

  const { data: { documentCategoriesByName } = defaultNormalizedDocumentCategoriesData } =
    useListDocumentCategoriesQuery();

  const getCategoryLabelByName = buildGetCategoryLabelByName(documentCategoriesByName);

  return (
    <ModalWindow
      onClose={() => {
        onCloseFinalizeModal();
        setDocToFinalize(null);
      }}
      title={<Header2Text>Finalize Document</Header2Text>}
      uitype={'fit'}
    >
      {fetching && <Spinner size={SpinnerSize.regular} />}
      {fetchError && (
        <BodyText>
          {typeof fetchError === 'string' ? fetchError : fetchError?.message || 'An unexpected error occurred.'}
        </BodyText>
      )}
      {success && docToFinalize && (
        <BodyText>
          {getCategoryLabelByName(docToFinalize.category)}
          Created
        </BodyText>
      )}
    </ModalWindow>
  );
};
